import { useAPIAuthenticatedService } from '../../helpers/APICallsAuthenticated';
import { CacheKeys } from '../../helpers/DataStructures';
import AdminGroupReferralsPage from './AdminGroupReferralsPage';

const AdminReferralsPage: React.FC = () => {
  const apiServiceInstance = useAPIAuthenticatedService();

  return (
    <AdminGroupReferralsPage
      emptyMessage="No referrals found for group 1."
      errorMessage="Unable to load group 1 referrals."
      loadReferrals={apiServiceInstance.getAdminGroupOneReferrals}
      queryKey={CacheKeys.ADMIN_REFERRALS_GROUP_ONE}
      title="All Referrals Group 1"
    />
  );
};

export default AdminReferralsPage;
